<template>
  <div class="activity-center">
    <div class="banner-brand">
      <img src="../../assets/imgs/logo.png" alt="Logo" class="brand-logo" />
      <span>广东省职业健康协会培训平台</span>
    </div>
    <div class="content-wrapper">
      <div class="banner">
        <div class="banner-text">
          <h2>健康中国 职业健康同行</h2>
        </div>
      </div>
      <div class="activities">
        <div
          class="activity-card"
          v-for="activity in activities"
          :key="activity.id"
          @click="viewDetail(activity)"
        >
          <div class="activity-banner">
            <img :src="activity.bannerUrl" alt="Activity Banner" />
          </div>
        </div>
      </div>
    </div>
    <!-- 页脚 -->
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-section">
          <h3>关于我们</h3>
          <p>致力于推动职业健康事业发展</p>
          <p>提供专业的职业健康培训和服务</p>
        </div>
        <div class="footer-section">
          <h3>联系信息</h3>
          <p>电话：020-84453099</p>
          <p>邮箱：gdzyjkxh@126.com</p>
          <p>地址：广东省广州市海珠区新港西路105号广东生物资源大厦A座607室</p>
        </div>
        <div class="footer-section">
          <h3>版权信息</h3>
          <p>&copy; 2025 广东省职业健康协会 版权所有</p>
          <p>技术支持 广州梦山科技有限公司</p>
        </div>
      </div>
      <div class="footer-bottom">
        <p>健康中国 职业健康同行 - 专业的职业健康服务平台</p>
        <p class="beian">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer"
            >粤ICP备13059083号</a
          >
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import kcbg3 from "@/assets/imgs/menu/1.png";
import kcbg4 from "@/assets/imgs/menu/2.png";
import kcbg5 from "@/assets/imgs/menu/3.png";
import kcbg6 from "@/assets/imgs/menu/4.png";
import kcbg7 from "@/assets/imgs/menu/5.png";
import logo from "@/assets/imgs/logo.png";
export default {
  name: "ThemeActivityCenterCopy",
  data() {
    return {
      keyword: "",
      status: "",
      type: "",
      activities: [
        {
          id: "1",
          title: "职业健康检查机构医疗卫生技术人员（职业健康检查知识培训）",
          shortTitle: "职业健康检查知识",
          description: "本专业考试相关知识培训，包括放射医学基础、临床应用等",
          startTime: "2024-06-01",
          endTime: "2024-06-30",
          location: "线上",
          organization: "广东省职业健康协会",
          status: "ongoing",
          type: "online",
          bannerUrl: kcbg4,
          participantsCount: 1256,
        },
        {
          id: "2",
          title: "放射工作人员放射防护培训",
          shortTitle: "放射防护",
          description: "CT技师考试重点难点解析，模拟试题练习，助您快速通关",
          startTime: "2024-07-15",
          endTime: "2024-07-30",
          location: "线上",
          organization: "广东省职业健康协会",
          status: "upcoming",
          type: "online",
          bannerUrl: kcbg7,
          participantsCount: 838,
        },
        {
          id: "3",
          title: "职业病诊断医师继续教育培训",
          shortTitle: "职业病诊断",
          description: "MRI医师资格考试系统培训，涵盖所有考试科目",
          startTime: "2024-05-01",
          endTime: "2024-05-15",
          location: "线上",
          organization: "广东省职业健康协会",
          status: "ended",
          type: "online",
          bannerUrl: kcbg6,
          participantsCount: 2890,
        },
        {
          id: "4",
          title: "职业卫生技术服务机构专业技术人员培训",
          shortTitle: "职业卫生技术",
          description: "核医学技术专业知识培训，包括放射性药物使用等",
          startTime: "2024-04-01",
          endTime: "2024-04-20",
          location: "线上",
          organization: "广东省职业健康协会",
          status: "ended",
          type: "online",
          bannerUrl: kcbg3,
          participantsCount: 456,
        },
        {
          id: "5",
          title: "用人单位职业健康培训（主要负责人、职业健康管理人员、劳动者）",
          shortTitle: "职业健康",
          description: "医学影像技术最新进展学习，包括人工智能在影像中的应用等",
          startTime: "2024-08-01",
          endTime: "2024-08-15",
          location: "线上",
          organization: "广东省职业健康协会",
          status: "upcoming",
          type: "online",
          bannerUrl: kcbg5,
          participantsCount: 678,
        },
      ],
    };
  },
  methods: {
    search() {
      console.log("搜索关键词:", this.keyword);
    },
    getStatusText(status) {
      const statusMap = {
        ongoing: "进行中",
        upcoming: "即将开始",
        ended: "已结束",
      };
      return statusMap[status] || status;
    },
    joinEvent(event) {
      console.log("参加活动:", event.title);
    },
    viewDetail(event) {
      this.$router.push({ path: "/login" });
    },
    viewMore() {
      console.log("查看更多活动");
    },
  },
};
</script>

<style scoped>
.activity-center {
  width: 100%;
  height: 100vh;
  background-image: url("../../assets/imgs/background.png");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #0f1d85;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  padding-top: 8px;
  box-sizing: border-box;
  overflow-y: auto;
  min-height: 0;
}

.activity-center svg {
  pointer-events: none;
}

.banner {
  width: 100%;
  max-width: 1200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  position: relative;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 0 20px;
}

.banner-brand {
  position: relative;
  top: 0;
  left: 0;
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
  padding: 8px 0;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-logo {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.banner-text h2 {
  color: white;
  font-size: 28px;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 20px;
}

.activities {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px 8px;
  display: grid;
  grid-template-columns: repeat(3, minmax(200px, 1fr));
  grid-auto-rows: auto;
  gap: 40px;
  align-items: start;
  box-sizing: border-box;
  transform-origin: top center;
}

.activity-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
  border: 1px solid #eee;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.activity-card:hover {
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.activity-banner {
  min-height: 160px;
  height: 200px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
}

.activity-banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.activity-card:hover .activity-banner img {
  transform: scale(1.05);
}

.activity-type-tag {
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 4px;
}

.activity-type-tag.online {
  background-color: #ebf8f0;
  color: #22543d;
  border: 1px solid #c6f6d5;
}

.activity-type-tag.offline {
  background-color: #fffaf0;
  color: #744210;
  border: 1px solid #fef5e7;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .activities {
    max-width: 100%;
    padding: 0 16px;
    grid-template-columns: repeat(1, 1fr);
    gap: 12px;
  }

  .footer-content {
    flex-direction: column;
    text-align: center;
  }
}

/* 页脚样式 */
.footer {
  background-color: #2d3748;
  color: white;
  padding: 6px 20px 4px;
  position: relative;
  width: 100%;
  flex-shrink: 0;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 6px;
}

.footer-section {
  flex: 1;
  min-width: 150px;
}

.footer-section h3 {
  margin-bottom: 3px;
  font-size: 11px;
  color: #fbbf24;
}

.footer-section p {
  margin-bottom: 2px;
  font-size: 10px;
  color: #e2e8f0;
  line-height: 1.3;
}

.footer-bottom {
  border-top: 1px solid #4a5568;
  padding-top: 4px;
  text-align: center;
  font-size: 9px;
  color: #a0aec0;
}

.beian {
  margin-top: 3px;
}

.beian a {
  color: #fff;
  text-decoration: none;
}

.beian a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
  }
}
</style>
